import { SliceComponentProps } from "@prismicio/react";
import { useQuery } from "@tanstack/react-query";
import _merge from "lodash/merge";
import { useFormContext } from "react-hook-form";

import PageImage from "components/pageImage/PageImage";
import { PagePreviewSlice } from "prismicio-types";
import { getToc, productKeys, useGetProduct } from "queries/product-queries";
import { useGetCustomisation } from "queries/product-queries";
import { SSR_CONFIGURATION_ERROR } from "utils/error-utils";

import styles from "./PagePreview.module.scss";

export default function PagePreviewField({
  slice,
}: SliceComponentProps<PagePreviewSlice>) {
  const { watch } = useFormContext();
  // Watch for changes in the form
  const customisations = watch();

  const { data: product } = useGetProduct();
  const { data: customisation } = useGetCustomisation();

  const combinedCustomisations = _merge({}, customisation, customisations);

  if (!product) {
    throw SSR_CONFIGURATION_ERROR;
  }
  const { data: toc, status: tocStatus } = useQuery({
    queryKey: productKeys.toc(product.museSlug, combinedCustomisations),
    queryFn: () => getToc(product.museSlug, combinedCustomisations),
    staleTime: Infinity,
  });

  const page = toc?.find(
    ({ info }) => info?.pageName === slice.primary.muse_page_id
  );

  if (tocStatus !== "loading" && !page) {
    throw new Error(`No page with name "${slice.primary.muse_page_id}"`);
  }

  return (
    <div className={styles.container}>
      {page && <PageImage page={page} pageNumber={0} />}
    </div>
  );
}
